import React, { Component } from 'react';
import { Link, withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import Pagination from "react-js-pagination";
import $ from 'jquery';
import {
  Row,
  Col,
  Modal,
  Table,
  OverlayTrigger,
  ButtonToolbar,
  Tooltip,
  Button
} from "react-bootstrap";
import moment from 'moment';
import { scrollToTopValidate,PageTitle } from "../Helpers/SettingHelper";
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';

import { GET_EVENTLIST,GET_DELETEEVENT  } from '../../actions';

class List extends Component {
  
  constructor(props)
  {
    super(props); 
    this.state = {
      eventlist:''
    };
    
    var qs = require('qs');
    var admin_id = localStorage.getItem("admin_id");
    var postobject = {
    activePage: 1,
    search_all: '',
    admin_id: admin_id
    };
    this.props.getEventList(qs.stringify(postobject));
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

   
    componentDidMount() {
      document.title = PageTitle('Event List');
      if(localStorage.getItem('admin_id') === null){
      this.props.history.push('/');
      }
   }

   handlePageChange(pageNumber) {
    // console.log(`active page is ${pageNumber}`);
     this.setState({activePage: pageNumber});

     var qs = require('qs');

     var admin_id = localStorage.getItem("admin_id");

     var postobject = {
       activePage: pageNumber,
       search_all: this.state.search_all,
       admin_id: admin_id
     };
     this.props.getEventList(qs.stringify(postobject))
   }

   handleInputChange(event) {
   const {name, value} = event.target;      
   this.setState({
     [name]: value
   });
   
 }

 handleFormSubmit = () => {
        
  this.setState({Loading:true});
  var qs = require('qs');
  const formPayload = this.state;
   var admin_id = localStorage.getItem("admin_id");
  var postObject = {             
    activePage   : 1,
    search_all : formPayload.search_all,
    admin_id: admin_id         
  };
  //console.log(postObject);
  this.props.getEventList(qs.stringify(postObject));

} 



   componentWillReceiveProps(Props){

    if (Object.keys(Props.eventlist).length > 0) {
      if (Props.eventlist[0]["status"] === "success") {
        this.setState({ totalRecord : Props.eventlist[0].records_count, eventlist: Props.eventlist[0]["eventlist"] });
      }
    }

    if (Object.keys(Props.deleteevent).length > 0) {
      if (Props.deleteevent[0]["status"] === "success") {
        this.setState({
          eventlist: Props.deleteevent[0]["eventlist"],
        });
      }

      this.setState({statusmessage: Props.deleteevent[0].message});

            setTimeout(
            function() {
              this.setState({statusmessage:''})
            }
            .bind(this),
            3000
          );
     window.location.reload(); 
    }
     
   }

   deleteevent(id){
    var qs = require('qs');
    var postObject = {
      admin_id : localStorage.getItem("admin_id"),
      event_id  :id
    };
    console.log(postObject);
  this.props.getDeleteEvent(qs.stringify(postObject));
  $('.statusmessage').html('<span>Deleting Event...Please wait to send notifications for group users.</span>');
}

eventlist() {
  
    var eventlist = this.props.eventlist[0];
    if (eventlist != "undefined" && eventlist != null) {
      if (eventlist.status == "success") {
        if (Object.keys(eventlist).length > 0) {
          const eventlistDetails = eventlist.eventlist.map(
            (eventlist, Index) => {
              let sno = Index+1;
              if(eventlist.event_status == 'A'){
                var status = 'Active';
              }else{
                  status = 'Inactive';
              }      
              var istyle = { width: 100};
              var startdata = moment(eventlist.event_start_date).format('MM/DD/YYYY')
              var enddate = moment(eventlist.event_end_date).format('MM/DD/YYYY')
              return (
              <tr key={eventlist.event_id}>
              <td>{sno}</td>
              <td>
              {eventlist.event_name}
              </td>                 
              <td>{eventlist.event_location}</td>
              <td>{startdata}</td>
              <td>{enddate}</td>
              <td>{eventlist.event_type}</td>
              <td>{status}</td>
              <td className="actiongroup">

              <Link to={{ pathname: '/event-edit/'+eventlist.event_id}} className="" title="Edit">  <i className="fa fa-edit" aria-hidden="true"></i></Link>
              <Link onClick={this.deleteevent.bind(this,eventlist.event_id)} className="" title="Duplicate">  <i className="fa fa-trash" aria-hidden="true"></i></Link>
              <Link to={{ pathname: '/event-view/'+eventlist.event_id}} className="" title="Edit">  <i className="fa fa-eye" aria-hidden="true"></i></Link>
              </td>
              </tr>
              );
            }
          );
          return eventlistDetails;
        }
      } else {
        return (
          <tr>
            <td colspan="8" className="v-align-nr">
              No Result
            </td>
          </tr>
        );
      }
    }else {
      return (
        <tr>
          <td colspan="8" className="v-align-nr">
            No Result
          </td>
        </tr>
      );
    }
  }
  


  render() {
    return (
      <div className="wrapper"> 
 
    <Header />
    <MenuSidebar currentpage="event" />  
      
      <div className="content"> 
        <div className="content-wrapper">
            <div className="car-listing-wrap">

              <div className="listing-header">
                <div className="title">
                  <h3>Events</h3>
                </div>

                <div className="search-list">
                   <form className="edit" id="edit" onSubmit={ e => { this.handleFormSubmit(this); e.preventDefault(); }} >     
                    <div className="search-inner">
                      <input type="text" name="search_all" onChange={this.handleInputChange} className="form-control" value={this.state.search_all} placeholder="Search" /> 
                     <button className="" type="submit">Submit</button>
                    <div className="erroremail"></div>
                  </div>
                 </form>
                </div>
                <div className="add_button">  
                    <a className="add" href='/event-add'>Add</a> 
                </div>  
              </div>            
              <div className="statusmessage"></div>

              <div className="car-listing-row">
                <Table striped bordered hover>
                  <thead>
                  <tr>
                  <th>S.No</th>
                  <th>Event</th>               
                  <th>Place</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Event Type</th>
                  <th>Status</th>
                  <th>Action</th>
                   </tr>
                  </thead>
                  <tbody>{this.eventlist()}</tbody>
                </Table>
                <div className="text-center">
                  <Pagination
                  activePage={this.state.activePage}
                  itemsCountPerPage={10}
                  totalItemsCount={this.state.totalRecord}
                  pageRangeDisplayed={5}
                  onChange={this.handlePageChange.bind(this)}
                  />
                </div>
              </div>

            </div> 
        </div>  
      </div>
      
    </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    eventlist: state.eventlist,
    deleteevent: state.deleteevent,
   

  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getEventList: (formVal) =>{
      dispatch({ type: GET_EVENTLIST, formVal});
   },
   getDeleteEvent: (formPayload) =>{
     dispatch({ type: GET_DELETEEVENT, formPayload });
   },
   
  }
}
export default connect(mapStateTopProps, mapDispatchToProps)(withRouter(List));